import React, { useContext, useEffect, useState } from 'react';
import { addCustomPathToLink, fetchProduct, sanitizeType, toggleFavourite } from '../../functions';
import styles from './WishlistModal.module.scss';
import { DataContext } from '../../views/pages/Root';

const WishlistItem = ({ id, type = null }) => {
  const data = useContext(DataContext);

  const [wishlistProduct, setWishlistProduct] = useState(null);
  const [wishlistProductLoader, setWishlistProductLoader] = useState(true);

  useEffect((_) => {
    const tempProduct = fetchProduct(id, setWishlistProduct, setWishlistProductLoader, data);
  }, []);

  if (wishlistProductLoader) return '...';
  else {
    if (!!wishlistProduct) {
      const regularPrice = !!wishlistProduct?.regularPrice ? wishlistProduct.regularPrice : wishlistProduct.salePrice;
      const salePrice = !!wishlistProduct?.salePrice && wishlistProduct.salePrice != regularPrice ? wishlistProduct.salePrice : null;

      return (
        <li className={`${styles.productItem} ${sanitizeType(type, styles)}`}>
          {!!wishlistProduct?.images && type != 'toPrint' && (
            <img
              className={styles.productImage}
              src={addCustomPathToLink(wishlistProduct.images[0]?.src, true)}
              srcSet={wishlistProduct.images[0]?.srcSet}
              alt={wishlistProduct.images[0]?.alt}
            />
          )}
          <div className={styles.productInfo}>
            {!!wishlistProduct?.name && <h3 className={styles.productTitle}>{wishlistProduct.name}</h3>}
            <ul className={styles.productInfoList}>
              {!!wishlistProduct?.desc && <li className={styles.productInfoItem}>{wishlistProduct.desc}</li>}
              {!!wishlistProduct?.id && <li className={styles.productInfoItem}>{wishlistProduct.id}</li>}
            </ul>
          </div>
          <div className={styles.actionsWrapper}>
            <p>
              {!!regularPrice && <span className={styles.productregularPrice}>{!!salePrice ? salePrice : regularPrice}</span>}
              {!!wishlistProduct?.currency && <span className={styles.productCurrency}>{wishlistProduct.currency}</span>}
            </p>
            {type != 'toPrint' && (
              <button
                className={styles.btnRemove}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  toggleFavourite(id);
                  setWishlistProduct(null);
                }}
              ></button>
            )}
          </div>
        </li>
      );
    }
  }
  return null;
};

export default WishlistItem;
